module.exports = __webpack_public_path__ + "img/2.6848440b.webp";